import {createAsyncThunk, PayloadAction, createAction, Action} from '@reduxjs/toolkit'
import ITab from '../../../../interface/core/ITab'

export const setActiveTab = createAction<ITab>('setActiveTab')
export const resetActiveTab = createAction('resetActiveTab')
